import React, { Component } from "react";
import * as Constants from "../Global/constants";
import {   } from "../Global/globalStyles.style";
import {
	getLocalStorageVariables,
	isEmptyArray,
	isEmptyVariable,
} from "../Global/commonFunctions";
import Select, { components } from "react-select";


let userDetails = getLocalStorageVariables();

class ReactSelectDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showLoader: false,
			datalist: [],
			menuIsOpen: undefined,
		};
		userDetails = getLocalStorageVariables();
	}

	componentDidMount() {
		let datalist = [];
		if(!isEmptyVariable(this.props.selectedDDObj)){
			datalist = this.props.selectedDDObj;
		}
		this.setState({
			componentDidMountFlag:false,
			showLoader:false,
			datalist:datalist,
		})
		document.addEventListener('scroll', this.handleScroll, true);
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.handleScroll, true);
	}

	handleScroll = () => {
		let isMultiselect = !isEmptyVariable(this.props.isMultiselect) && this.props.isMultiselect;
		if(!isMultiselect && this.state.menuIsOpen){
			this.setState({ menuIsOpen: false });
		}
	}

	handleMenuOpen = () => {
		this.setState({ menuIsOpen: true });
	}

	handleMenuClose = () => {
		this.setState({ menuIsOpen: false });
	}

	componentDidUpdate(prevProps)
	{
		if(prevProps.selectedDDObj!==this.props.selectedDDObj)
		{
			let datalist = [];
			datalist = this.props.selectedDDObj;
		this.setState({
			componentDidMountFlag:false,
			showLoader:false,
			datalist:datalist,
		})

		}
	}
	

	// handleDialogClose = () => {
	// 	this.props.handleReactSelectClose(this.state.datalist);
	// };

	handleOnChangeSelectedOption = (newValueObj, actionMeta) => {
		// if (actionMeta.action === "select-option") {
		// 	
		// } else if (actionMeta.action === "create-option") {
		// 	
		// } else if (actionMeta.action === "remove-value") {
		// 	
		// }

		this.setState(
			{
				datalist: newValueObj,
			},()=>{
				this.props.handleReactSelectClose(this.state.datalist);
			
					
				
			});
	};

	render() {
		return (
			<div >
			 <Select
					value={this.state.datalist}
					onChange={this.handleOnChangeSelectedOption}
					options={this.props.selectDropdownArr}
					placeholder={(!isEmptyVariable(this.props.placeholder) || !isEmptyVariable(this.state.datalist))?this.props.placeholder:"Please select"}
					getOptionLabel={(option) => option[this.props.label]}
					getOptionValue={(option) => option[!isEmptyVariable(this.props.value)?this.props.value:this.props.label]}
					formatOptionLabel={this.props.formatOptionLabel}
					isDisabled={!isEmptyVariable(this.props.disabled) && this.props.disabled?true:false}
					isMulti={!isEmptyVariable(this.props.isMultiselect) && this.props.isMultiselect?true:false}
					search ={true}
					isClearable={!isEmptyVariable(this.props.isClearSelect) && this.props.isClearSelect?true:false}
					menuPlacement={!isEmptyVariable(this.props.isMultiselect) && this.props.isMultiselect?"bottom":"auto"}
					menuIsOpen={!isEmptyVariable(this.props.isMultiselect) && this.props.isMultiselect?undefined:this.state.menuIsOpen}
					onMenuOpen={this.handleMenuOpen}
					onMenuClose={this.handleMenuClose}
					menuPortalTarget={document.body}
					styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
				/>
			</div>
		);
	}
}

export default ReactSelectDropdown;
